import { render, staticRenderFns } from "./ProductsWithVideoProductCard.vue?vue&type=template&id=402213f0&scoped=true&"
import script from "./ProductsWithVideoProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductsWithVideoProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductsWithVideoProductCard.vue?vue&type=style&index=0&id=402213f0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402213f0",
  null
  
)

export default component.exports